import { Component, OnInit } from "@angular/core";
import { MDBModalService } from "angular-bootstrap-md";
import { EntityType } from '../../models/enums/entityType';
import { CatalogueListColumn } from "../readonly-list.component/readonly-list.component";
import { StructureSet } from './../../models/structure-set.model';
import { ModelService } from "./../../services/model.service";
import { CommonTools } from "./../../shared/helpers/common-tools";
import { StructureSetModalComponent } from "./structure-set-modal/structure-set-modal.component";

@Component({
    selector: "app-structure-set-list",
    templateUrl: "./structure-set-list.component.html",
    styleUrls: ["./structure-set-list.component.scss"],
})
export class StructureSetListComponent implements OnInit {
    dataSource: StructureSet[] = [];

    constructor(private model: ModelService, private mbdModalService: MDBModalService) { }

    ngOnInit() {
        this.model.SelectedProject$.subscribe((project) => {
            this.dataSource = project.structureSet ? project.structureSet : [];
        });
    }

    defineColumns() {
        const columns: CatalogueListColumn[] = [];

        let column = new CatalogueListColumn();
        column.heading = "Název";
        column.dataSourceColumnName = "name";
        columns.push(column);

        column = new CatalogueListColumn();
        column.heading = "Popis";
        column.dataSourceColumnName = "description";
        columns.push(column);

        return columns;
    }

    onAddOne() {
        this.openModal();
    }

    onCopyOne(externalId: string) {
        var structureSet: StructureSet = this.model.getEntityByExternalId(EntityType.StructureSet, externalId);
        var clone = Object.assign(new StructureSet(), structureSet);
        clone.externalId = CommonTools.GetUUID();
        this.model.AddEntity(clone);
    }

    onUpdateOne(data: any) {
        this.model.UpdateEntity(data);
    }

    onDeleteOne(externalId: any) {
        this.model.RemoveEntityByExternalId(EntityType.StructureSet, externalId);
    }

    onDetail(externalId: string) {
        this.openModal(externalId);
    }

    private openModal(externalId?: string) {
        this.mbdModalService.show(StructureSetModalComponent, {
            containerClass: "modal fade",
            class: "modal-dialog modal-dialog-scrollable modal-xl",
            animated: true,
            data: {
                externalId: externalId,
                projectId: this.model.SelectedProject.externalId,
            },
        });
    }
}
